/*
 * @Author: kevinqq 350910378@qq.com
 * @Date: 2025-02-28 14:16:57
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-31 15:01:04
 * @FilePath: \baishu_react_ui\src\components\dashboard\BsyDashboardAppGroupDesign\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import "./index.css";
import _ from "lodash";
import GroupConfig from "./GroupConfig";
import AppGroup from "./AppGroup";

export default class BsyDashboardAppGroupDesign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: _.cloneDeep(props.apps),
    };
    this.element = React.createRef();
    this.refGroupConfig = React.createRef();
  }

  jumpGroup = (id) => {
    const group = this.element.current.querySelector(`.id-${id}`);
    group?.scrollIntoView?.({ behavior: "smooth", block: "center" });
    // let pos = 0;
    // for (let index = 0; index < group.length; index++) {
    //   const element = group[index];
    //   if (element.classList.contains(`id-${id}`)) {
    //     break;
    //   }
    //   pos += element.offsetHeight;
    // }

    // const sort = this.element.current.querySelector(`.bsy-sortable-columns`);
    // sort && (sort.scrollTop = pos);
  };

  checkGroup = () => {
    return this.refGroupConfig.current?.checkGroup();
  };

  render() {
    return (
      <div className="app-group-design" ref={this.element}>
        <AppGroup
          apps={this.state.apps}
          onSetGroup={(apps) => {
            this.setState({ apps }, () => {
              this.props && this.props.onChange(apps);
            });
          }}
        />
        <GroupConfig
          ref={this.refGroupConfig}
          apps={this.state.apps}
          onSetGroup={(apps) => {
            this.setState({ apps }, () => {
              this.props && this.props.onChange(apps);
            });
          }}
          onJumpGroup={(e) => {
            this.jumpGroup(e);
          }}
        />
      </div>
    );
  }
}
